// extracted by mini-css-extract-plugin
export default {"popupContainer":"detail_popupContainer__TvExS","messageContainer":"detail_messageContainer__DJuSU"};